import {createSlice} from '@reduxjs/toolkit';

export const pepirisDisplayInitial = {
  bannerImage: null,
  thumbnailImage: null,
  guidelineImage: null,
  bannerText: {},
  targetGuidelinesEnabled: false,
  photoGuidelinesEnabled: false,
  targetGuidelines: [],
  photoGuidelines: []
};

export const perfectStoreInitialFormData = {
  targetType: '',
  name: '',
  nameValid: undefined,
  status: 'Draft',
  activeStartDate: '',
  activeStartDateValid: undefined,
  activeEndDate: '',
  activeEndDateValid: undefined,
  rewardDate: '',
  rewardDateValid: undefined,
  hasDisplayDate: false,
  displayStartDate: '',
  displayStartDateValid: undefined,
  displayEndDate: '',
  displayEndDateValid: undefined,
  awardPointsWhenTargetMet: false,
  requiredUserToJoin: false,
  targetMediaFile: [],
  storeTargetFileUrl: '',
  updatedAt: null,
  displayContent: {
    bannerImage: null,
    bannerText: {},
    rackDisplays: []
  },
  pepirisDisplay: {...pepirisDisplayInitial},
  // PepIris-specific fields
  taskName: '',
  targetCoolerPurity: '',
  targetCoolerPurityValid: undefined,
  minimumDistinctSku: '',
  minimumDistinctSkuValid: undefined,
  submissionDate: '',
  submissionDateValid: undefined,
  hasValidationDate: true,
  validationDate: '',
  validationDateValid: undefined
};

export const perfectStoreInitialState = {
  formData: {...perfectStoreInitialFormData},
  id: null,
  uuid: null,
  status: null
};

const perfectStoreSlice = createSlice({
  name: 'perfectStore',
  initialState: perfectStoreInitialState,
  reducers: {
    setPerfectStoreFormData: (state, action) => ({
      ...state,
      formData: {
        ...state.formData,
        ...action.payload
      }
    }),
    resetPerfectStoreFormData: (state, action) => ({
      ...state,
      formData: {
        ...perfectStoreInitialFormData,
        ...(action.payload || {})
      }
    }),
    resetPerfectStore: () => ({...perfectStoreInitialState}),
    setPerfectStoreMeta: (state, action) => ({
      ...state,
      ...action.payload
    })
  }
});

export const {
  setPerfectStoreFormData,
  resetPerfectStoreFormData,
  resetPerfectStore,
  setPerfectStoreMeta
} = perfectStoreSlice.actions;

export const perfectStoreSliceReducer = perfectStoreSlice.reducer;
